import { el } from '../dom';
import { getLocale, setLocale, type Locale } from './index';

export function buildLocalePicker(): HTMLElement {
  const wrap = el('div', 'locale-picker');
  const current = getLocale();
  for (const loc of ['ru', 'en'] as Locale[]) {
    const btn = el('button', `locale-btn ${loc === current ? 'on' : ''}`, loc.toUpperCase()) as HTMLButtonElement;
    btn.type = 'button';
    btn.dataset.key = `locale-${loc}`;
    btn.addEventListener('click', () => setLocale(loc));
    wrap.appendChild(btn);
  }
  return wrap;
}
